<div id="content" class="allcp-form" ng-controller="AccountController" ng-init="smsProvider()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    
    <div class="row">
        <div class="panel">
            
            <div class="panel-heading">
                <span class="panel-title"> Sms Sağlayıcı Entegrasyonu
        
                </span>
                <hr>
            </div>
            <div class="panel-body allcp-form theme-primary">
                <div class="row">
                    
                        <div class="col-md-8">
                            <form class="form-horizontal" ng-submit="updateSmsProvider(sms_provider)">
                            
                            <div class="form-group">
                                <label for="store-name-7" class="col-md-3 control-label">Sms Firması* : </label>
                                <div class="col-md-9">
                                    <label for="store-name-7" class="field select">
                                        <select ng-model="sms_provider.sms_provider" class="gui-input" required>
                                            <option value="NETGSM" ng-selected="true">NETGSM</option>
                                            <option value="BIZIMSMS" ng-selected="true">Bizim SMS</option>
                                        </select>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="store-name-7" class="col-md-3 control-label">Sms Firması Kullanıcı Adı* : </label>
                                <div class="col-md-9">
                                    <label for="store-name-7" class="field prepend-icon">
                                        <input type="text" placeholder="Sms Firması Kullanıcı Adı" class="gui-input" ng-model="sms_provider.username" required>
                                        <label for="store-name-7" class="field-icon">
                                            <i class="fa fa-users"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="store-name-7" class="col-md-3 control-label">Sms Firması Şifre* : </label>
                                <div class="col-md-9">
                                    <label for="store-name-7" class="field prepend-icon">
                                        <input type="text" placeholder="Sms Firması Şifre" class="gui-input" ng-model="sms_provider.password" required>
                                        <label for="store-name-7" class="field-icon">
                                            <i class="fa fa-key"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="store-name-7" class="col-md-3 control-label">Sms Başlığı* : </label>
                                <div class="col-md-9">
                                    <label for="store-name-7" class="field prepend-icon">
                                        <input type="text" placeholder="Sms Başlığı" class="gui-input" ng-model="sms_provider.header" required>
                                        <label for="store-name-7" class="field-icon">
                                            <i class="fa fa-header"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="store-name-7" class="col-md-3 control-label">Durum * : </label>
                                <div class="col-md-9">
                                    <div class="radio-custom mb20">
                                        <input type="radio" id="active" name="status" 
                                            ng-value="true"
                                            ng-model="sms_provider.status">
                                        <label for="active" class="pt5">Aktif</label>
                                    </div>
                                    <div class="radio-custom mb20">
                                        <input type="radio" id="passive" name="status" 
                                            ng-value="false"
                                            ng-model="sms_provider.status">
                                        <label for="passive" class="pt5">Pasif</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-12">
                                    <div class="pull-right">
                                        <button type="submit" class="btn btn-primary">Bilgileri Güncelle</button>
                                    </div>
                                </div>
                            </div>
                            </form>                            
                        </div>
                        <div class="col-md-4" ng-if="sms_provider.status">
                            <h5> Test Sms Gönder</h5>
                            <hr>
                            <p>
                                <strong> Not:</strong> Test sms göndererek sms servis sağlayacı bilgilerinizin doğruluğundan emin olun.
                            </p>
                            <form class="form-horizontal" ng-submit="sendTestSms(test_sms_number)" >
                                <div class="form-group">
                                    <label for="store-name-7" class="control-label">Sms Gönderilecek Numara* : </label>
                                    <label for="store-name-7" class="field">
                                        <input 
                                            type="text" 
                                            class="form-control md" 
                                            ui-mask="(999) 999-9999"  
                                            ui-mask-placeholder ui-mask-placeholder-char=" " 
                                            ng-model="test_sms_number"
                                            required>
                                    </label>
                                </div>
    
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <div class="pull-right">
                                            <button type="submit" ng-if="!loadingsms" class="btn btn-primary">Sms Gönder</button>
                                            <button type="submit" ng-if="loadingsms" ng-disabled="true" class="btn btn-primary">Sms Gönderiliyor...</button>
                                        </div>
                                    </div>
                                </div>
    
                            </form>
                        </div>

                </div>
            </div>

    </div>
</div>